import { BoxProps, TextProps } from '@jfs/ui-new'
import { SpacerProps } from '@jfs/ui-new/src/comps/SpacerNew'

const styles = {
  formContainer: {
    zIndex: 5,
    w: '100%',
  } as BoxProps,

  innerContainer: {
    width: '100%',
    alignSelf: 'center',
    marginBottom: 60,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: 'BORDER_COLOR',
  } as BoxProps,

  listItem: {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 15,
      paddingVertical: 15,
    } as BoxProps,
    leftContainer: {
      flexDirection: 'column',
      flex: 1,
    } as BoxProps,
    rightContainer: {
      maxWidth: '50%',
      paddingLeft: 20,
    },
    tittle: { fontSize: 12, color: 'DARK_GREY_2', fontFamily: 'jiotype-medium' } as TextProps,
    verticalSpacerProps: { direction: 'vertical', size: 8 } as SpacerProps,
    subTittle: { fontSize: 10, color: 'PRIMARY_GREY', fontFamily: 'jiotype-medium' } as TextProps,
    value: { fontSize: 12, fontWeight: '700', color: 'BLACK_21' } as TextProps,
    horizonatalSpacerProps: { direction: 'horizontal', size: 16 } as SpacerProps,
  },
  otpDialog: {
    container: {
      padding: 40,
      bg: 'WHITE',
      width: '25%',
      alignSelf: 'center',
      borderRadius: 8,
      justifyContent: 'center',
      minWidth: 400,
      alignItems: 'center',
    } as BoxProps,
    tittle: { fontSize: 24, fontFamily: 'jioType-bold', color: 'BLACK' } as TextProps,
    button: {
      padding: 15,
      width: '100%',
      borderRadius: 2,
      justifyContent: 'center',
      alignItems: 'center',
    } as BoxProps,
  },
}

export default styles
